export const getScrollTop = (
  el: HTMLElement = document.scrollingElement as HTMLElement
) => el.scrollTop;
